module.exports = __webpack_public_path__ + "static/media/teach_and_engage.46b1d688.svg";